import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "block" }
const _hoisted_2 = { class: "bg-white-100 flex justify-center px-8 md:px-0" }
const _hoisted_3 = { class: "container mt-12 md:mt-24 mb-81 relative" }
const _hoisted_4 = { class: "space-y-8 md:flex md:space-y-0 md:space-x-24" }
const _hoisted_5 = { class: "md:w-5/12" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "w-full absolute -bottom-124 md:-bottom-136 flex" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "bg-red-100 flex justify-center px-8 md:px-0" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  id: "download-app",
  class: "scroll-section"
}, null, -1)
const _hoisted_12 = { class: "lg:mt-84 mt-68 mb-24 container space-y-8 lg:flex lg:flex-row-reverse lg:space-y-0" }
const _hoisted_13 = { class: "lg:w-7/12 lg:ml-24 space-y-5 lg:my-auto" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "mt-8 flex space-x-4" }
const _hoisted_17 = ["href"]
const _hoisted_18 = ["src"]
const _hoisted_19 = ["href"]
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "lg:w-5/12" }
const _hoisted_22 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h1", {
              class: "my-auto",
              innerHTML: _ctx.highlightedSaveLivesTitle
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("div", {
            class: "md:w-7/12 space-y-5",
            innerHTML: _ctx.$t('help_saving_lifes.content')
          }, null, 8, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("img", {
            class: "h-84 md:h-112 w-full rounded-2xl",
            src: _ctx.$t('help_saving_lifes.image')
          }, null, 8, _hoisted_9)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("h1", { innerHTML: _ctx.highlightedDownloadAppTitle }, null, 8, _hoisted_14),
          _createElementVNode("div", {
            innerHTML: _ctx.$t('download_app.content')
          }, null, 8, _hoisted_15),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("a", {
              target: "_blank",
              href: _ctx.$t('download_app.app_store_url')
            }, [
              _createElementVNode("img", {
                class: "w-40 h-12",
                src: _ctx.$t('download_app.app_store_download_image')
              }, null, 8, _hoisted_18)
            ], 8, _hoisted_17),
            _createElementVNode("a", {
              target: "_blank",
              href: _ctx.$t('download_app.google_play_url')
            }, [
              _createElementVNode("img", {
                class: "w-40 h-12",
                src: _ctx.$t('download_app.google_store_download_image')
              }, null, 8, _hoisted_20)
            ], 8, _hoisted_19)
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("img", {
            class: "h-180 max-w-136 mx-auto w-full rounded-2xl",
            src: _ctx.$t('download_app.image')
          }, null, 8, _hoisted_22)
        ])
      ])
    ])
  ]))
}